<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle
          :title="$t('page_title.Site_footer_Settings')"
          :newButShow="true"
          @newBut="newBut('add')"
        ></pageTitle>
        <myTable ref="table" :columns="columns" requestUrl="teacher-profile/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Icon
              class="cursor_p"
              @click="handleToDetail(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />
            <!-- <a @click="newBut(data.row)">{{ $t("edit") }}</a> -->
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import edit from "./module/infoItem_edit";
export default {
  name: "expire",
  components: {
    myTable,
    pageTitle,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "teacher_id",
          align: "center"
        },
        {
          title: this.$t("Info.footer_title") + "(EN)",
          key: "teacher_cname",
          align: "center"
        },
        {
          title: this.$t("Info.footer_title") + "(繁体)",
          key: "contact_mobile",
          align: "center"
        },
        {
          title: this.$t("Info.footer_title") + "(简体)",
          key: "teacher_email",
          align: "center"
        },
        {
          title: this.$t("Info.order"),
          key: "renewal_time",
          align: "center"
        },
        {
          title: this.$t("status"),
          key: "renewal_time",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.isUpload == 1
              },
              on: {
                'on-change': value => {
                  let id = params.row.id;
                  if (value == false) {
                    var op = 0;
                  } else {
                    var op = 1;
                  }
                  //   this.setStatus(id, op);
                }
              }
            });
          }
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action"
        },
      ],
      modal: false,
      itemObj: {},
      type: "add"
    };
  },
  created () {
  },
  mounted () {
      this.$base.setMenuOpens();
  },
  methods: {
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    handleToDetail (item) {
      this.$base.linkTo("/edu/item-info", { id: item.log_id });
    },
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/edu/infoItem/infoItem.vue